type ContentProps = {
  children: React.ReactNode;
  id?: string;
};

export const Content = ({ children, id }: ContentProps) => {
  return (
    <div id={id} className='mb-10 flex flex-1 flex-col gap-4 pt-5 sm:flex-none'>
      {children}
    </div>
  );
};
